import { CreditBalance, Transaction, TrialStatus } from "../model/creditHistoryModel";

export type CreditHistoryAction =
  | { type: "SET_CREDIT_HISTORY"; payload: Transaction[] }
  | { type: "SET_LOADING"; payload: boolean }
  | { type: "SET_ERROR"; payload: string | null }|
  { type: "SET_TOTAL"; payload: number }|
  { type: "SET_START_DATE"; payload: string }|
  { type: "SET_END_DATE"; payload: string }
  | { type: "SET_PAGE"; payload: number }
  | { type: "SET_PAGE_SIZE"; payload: number }
  |{type:"SET_TRIAL_STATUS"; payload: TrialStatus}
  |{ type: "RESET_FILTER" }
  |{type:"SET_SEARCHED"}
    | { type: "NEXT_PAGE" }
  | { type: "PREV_PAGE" }|
  { type: "SET_HAS_MORE"; payload: boolean };



  export const setCreditHistory = (payload: Transaction[]): CreditHistoryAction => ({
    type: "SET_CREDIT_HISTORY",
    payload,
  });
  export const setLoading = (payload: boolean): CreditHistoryAction => ({
    type: "SET_LOADING",
    payload,
  });
export const setError = (payload: string | null): CreditHistoryAction => ({
    type: "SET_ERROR",
    payload,
    });
  export const setTotal = (payload: number): CreditHistoryAction => ({
    type: "SET_TOTAL",
    payload,
  });
  export const setHasMore = (payload: boolean): CreditHistoryAction => ({
    type: "SET_HAS_MORE",
    payload,
  });
  export const setStartDate = (payload: string): CreditHistoryAction => ({
    type: "SET_START_DATE",
    payload,
  });
  export const setEndDate = (payload: string): CreditHistoryAction => ({
    type: "SET_END_DATE",
    payload,
  });
  export const setPage = (payload: number) => ({
  type: "SET_PAGE",
  payload,
});

export type GetCreditBalaceAction = { type: "GET_BALANCE" } | { type: "SET_BALANCE", payload: CreditBalance }


export const setBalance = (payload: CreditBalance): GetCreditBalaceAction => ({
  type: "SET_BALANCE",
  payload,
});
